






import { Component, Vue } from 'vue-property-decorator';
import { auth, signInWithGoogle } from '@/firebaseConfig';

@Component({})
export default class Login extends Vue {
  signInWithGoogle() {
    signInWithGoogle();
  }
}
